import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { DragSourceMonitor, useDrag } from 'react-dnd';
import { setDraggingProps } from '../../stores/actions/user-interface';
import type { DragItem } from '../../stores/types/user-interface';

const useDragItem = (dragItemData: DragItem, dragEnabled: boolean = true) => {
	const dispatch = useDispatch();

	const [{ isDragging }, connectDragRef, dragPreview] = useDrag(() => ({
		type: dragItemData.type,
		item: {...dragItemData},
		canDrag: () => dragEnabled,
		collect: (monitor: DragSourceMonitor) => ({
			isDragging: !!monitor.isDragging(),
		}),
		end: () => dispatch(setDraggingProps(null)),
	}), [dragItemData.type, dragItemData.id, dragEnabled]);

	useEffect(() => {
		if (isDragging) {
			dispatch(setDraggingProps({
				globalIsDragging: true,
				idOfDragging: dragItemData.id,
				typeOfDragging: dragItemData.type,
			}));
		}
	}, [isDragging]);

	const dragRef = useCallback((node: Element | null) => {
		connectDragRef(node);
	}, [connectDragRef]);

	return {
		dragRef,
		isDragging,
		dragPreview
	};
};

export default useDragItem;
